/**
 * Read a cookie value by name using the native document.cookie API.
 * @param {string} name Cookie name
 * @returns {string|undefined} Cookie value, or undefined if not found
 */
export function getCookieValue(name) {
  const match = document.cookie.match(
    new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*=\\s*([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}
